require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconStarOutlined.tsx
var IconStarOutlined_exports = {};
__export(IconStarOutlined_exports, {
  default: () => IconStarOutlined_default
});
module.exports = __toCommonJS(IconStarOutlined_exports);

// src/assets/monochrome/starOutlined.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgStarOutlined = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99994 3.65062L8.57044 6.54711C8.14443 7.4103 7.32094 8.0086 6.36835 8.14702L3.17189 8.61149L5.48487 10.8661C6.17418 11.538 6.48872 12.5061 6.326 13.4548L5.77997 16.6383L8.63898 15.1353C9.491 14.6873 10.5089 14.6873 11.3609 15.1353L14.2199 16.6383L13.6739 13.4548C13.5112 12.5061 13.8257 11.538 14.515 10.8661L16.828 8.61149L13.6315 8.14702C12.6789 8.0086 11.8555 7.4103 11.4294 6.54711L9.99994 3.65062ZM0.935591 8.9453L4.22845 12.155C4.49352 12.4134 4.61447 12.7857 4.5519 13.1505L3.77456 17.6828C3.61698 18.6015 4.58131 19.3021 5.40639 18.8683L9.47659 16.7285C9.80423 16.5563 10.1957 16.5563 10.5233 16.7285L14.5935 18.8683C15.4186 19.3021 16.3829 18.6015 16.2253 17.6828L15.448 13.1505C15.3854 12.7857 15.5064 12.4134 15.7714 12.155L19.0643 8.9453C19.7318 8.29464 19.3635 7.16101 18.441 7.02697L13.8904 6.36573C13.5241 6.3125 13.2074 6.08242 13.0436 5.75049L11.0085 1.62693C10.5959 0.791025 9.40396 0.791025 8.99142 1.62693L6.95632 5.75049C6.7925 6.08242 6.47583 6.3125 6.10952 6.36573L1.55889 7.02697C0.636422 7.16101 0.268084 8.29464 0.935591 8.9453Z", fill: "#676F7E" }) });
var starOutlined_default = SvgStarOutlined;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconStarOutlined.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconStarOutlined = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(starOutlined_default, {}) });
};
IconStarOutlined.displayName = "IconStarOutlined";
var IconStarOutlined_default = IconStarOutlined;
